import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Tooltip from '../common/Tooltip'
import { ReactComponent as DownloadIcon } from '../../../assets/images/download-2.svg'
import { ReactComponent as CollectionFillIcon } from '../../../assets/icons/collection-fill.svg'
import { ReactComponent as NarrowViewSelected } from '../../../assets/icons/narrow-view-selected.svg'
import { ReactComponent as ChatIcon } from '../../../assets/icons/chat.svg'
import { ReactComponent as WarningIcon } from '../../../assets/icons/warning.svg'
import Http from '../../helpers/Http'
import { closeLoader, openLoader, useLoader } from '../../redux_toolkit/Loader'
import {
    addToDraft,
    approveQuotesByFolder,
    fetchFavouriteDetailsLists,
    fetchFavouriteDetailsListTableData,
    fetchFavouriteProductsByFolderId,
    fetchFolderDetailsById,
    fetchLikedDesignCountByFolder,
    fetchLikedProductInfoByFolder,
    hideLikedProduct,
    removeFromdraft,
    undoFavourite
} from '../../services/v3/Favourite/FavouriteService'
import {
    capitalizeFirstAndLowercaseRest,
    capitalizeFirstLetter,
    downloadBlobFIle,
    getBreadCrumbs,
    getUserPreference,
    isAllIdExistBetweenTwoList,
    isPageReachBottom,
    isPickAndChooseBuyer,
    printApiError
} from '../../helpers/Util'
import {
    addMixpanelTrackingEvent,
    setSystemUserPreferences
} from '../../services/CommonService'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete.svg'
import { ReactComponent as PlusIcon } from '../../../assets/icons/plus.svg'
import { ReactComponent as CollectionUnFillIcon } from '../../../assets/icons/collection-unfill.svg'
import { ReactComponent as PlayIcon } from '../../../assets/icons/play.svg'
import { ReactComponent as ListViewUnfillIcon } from '../../../assets/icons/list-view-unfill.svg'
import { ReactComponent as LeftArrowIcon } from '../../../assets/icons/arrow-left.svg'
import { ReactComponent as RightArrowIcon } from '../../../assets/icons/arrow-right.svg'
import { ReactComponent as DownArrowIcon } from '../../../assets/icons/arrow-down.svg'
import { ReactComponent as MinusIcon } from '../../../assets/icons/minus.svg'
import { ReactComponent as SelectedListViewIcon } from '../../../assets/icons/list-view-filled.svg'
import { ReactComponent as SelectedCardViewIcon } from '../../../assets/icons/grid-view-active.svg'
import BreadCrumb from '../common/BreadCrumb'
import PresentationViewModal from '../common/PresentationViewModal'
import AddPeople from '../common/AddPeople'
import { FavouriteThunks } from '../../redux_toolkit/Favourite/FavouriteThunks'
import { GET_FAVOURITE_COUNT } from '../../redux_toolkit/@types/thunk.types'
import RequestForSample from '../../common/RequestForSample'
import RequestForQuotes from '../../common/RequestForQuotes'
import CustomDropdown from '../common/CustomDropdown'
import TableView from './TableView'
import PlaceOrder from '../../modules/quote/PlaceOrder'
import DesignImages from '../common/DesignImages'
import PackSetOrTag from '../common/PackOrSetTag'
import SetStyleMainFabricType from '../common/SetStyleMainFabricType'
import { openDesignView } from '../../redux_toolkit/Design/DesignViewSlice'
import { openConversationView } from '../../redux_toolkit/Conversation/ConversationViewSlice'

const sortOptions = [
    {
        key: 'Default',
        value: '',
        constant: 'CATEGORY'
    },
    {
        key: 'Category',
        value: 'category.id,desc',
        constant: 'CATEGORY'
    },
    {
        key: 'Fabric Type',
        value: 'fabricType,asc',
        constant: 'FABRIC_TYPE'
    },
    {
        key: 'Qty high to low',
        value: 'quantity,desc',
        constant: 'CATEGORY'
    },
    {
        key: 'Qty low to high',
        value: 'quantity,asc',
        constant: 'CATEGORY'
    }
]

const FavouriteDetails = () => {
    const [isShowSample, setIsShowSample] = useState(false)
    const [favouriteList, setFavouriteList] = useState([])
    const [draftList, setDraftList] = useState([])
    const [isQuoteShow, setIsQuoteShow] = useState(false)
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedProductList, setSelectedProductList] = useState([])
    const [folderInfo, setFolderInfo] = useState(null)
    const [isShowDraft, setIsShowDraft] = useState(true)
    const [isShowPresentation, setIsShowPresentation] = useState(false)
    const [sort, setSort] = useState(sortOptions[0])
    const [viewType, setViewType] = useState(null)
    const [showOptions, setShowOptions] = useState(false)
    const [isOrderDisable, setIsOrderDisable] = useState(false)
    const [isPlaceOrder, setIsPlaceOrder] = useState(false)
    const [totalItemsCount, setTotalItemsCount] = useState({})
    const [categoryWiseCountList, setCategoryWiseCountList] = useState([])
    const [fabricTypeWiseCountList, setFabricTypeWiseCountList] = useState([])
    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    const [selectedCategoryTab, setSelectedCategoryTab] = useState(null)
    const [styleListForMentions, setStyleListForMentions] = useState([])
    const isLoading = useRef(null)
    const globalLoader = useLoader(null)
    const dispatch = useDispatch()
    const scrollRef = useRef()
    const draftScrollRef = useRef()
    const { id } = useParams()
    const navigate = useNavigate()
    const breadCrumbs = getBreadCrumbs()

    const fetchFolderInfos = async () => {
        let params = ''
        if (id && id !== 'my-favourite') {
            params += `?folderId=${id}`
            const data = await fetchFolderDetailsById(params)
            setFolderInfo(data)
        } else {
            const data = await fetchFolderDetailsById(params)
            setFolderInfo(data)
        }
    }

    const setIsDataLoading = (data) => {
        isLoading.current = data
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const isShowComment = params.get('showComment')
        if (isShowComment) {
            handleOpenFolderConversation()
        }
    }, [id])

    // For hide the bottom footer
    useEffect(() => {
        const element = document.getElementById('mobile-footer')
        if (element) {
            if (selectedIds.length > 0 || draftList?.length >= 0) {
                element.classList.add('hide-mobile-footer')
            } else {
                element.classList.remove('hide-mobile-footer')
            }
        }
    }, [selectedIds])

    useEffect(() => {
        setIsShowDraft(
            draftList?.length > 0 &&
                viewType !== 'TABLE_VIEW' &&
                screenWidth > 640
        )
    }, [draftList, viewType])

    useEffect(() => {
        fetchDesignList(0, false)
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [sort, viewType])

    useEffect(() => {
        fetchFolderInfos()
        if (viewType !== 'TABLE_VIEW') {
            fetchDesignList(0, true)
            document.addEventListener('scroll', handleDraftScroll)
            return () => {
                document.removeEventListener('scroll', handleDraftScroll)
            }
        }
    }, [viewType])

    useEffect(() => {
        setIsDataLoading(globalLoader)
    }, [globalLoader])

    useEffect(() => {
        let type = getUserPreference()?.favouriteDetailsViewType || 'CARD_VIEW'
        setViewType(type)
    }, [])

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        findFirstMatchAndBreak()
    }, [selectedIds])

    function findFirstMatchAndBreak() {
        let quoteList = favouriteList || []
        for (const item of quoteList) {
            if (isDisabled(item)) {
                setIsOrderDisable(true)
                return item
            }
        }
        setIsOrderDisable(false)
        return null
    }

    const isDisabled = (quoteItem) => {
        return (
            selectedIds?.length > 0 &&
            quoteItem?.quoteStatus !== 'APPROVED' &&
            selectedIds?.includes(quoteItem?.id)
        )
    }

    const toggleDesignViewType = async (type) => {
        setSelectedIds([])
        await setSystemUserPreferences({
            favouriteDetailsViewType: type
        })
        setSort(sortOptions[0])
        setSelectedCategoryTab({
            categoryName: 'Total'
        })
        setViewType(type)
        const requestBody = {
            viewType: type
        }
        addMixpanelTrackingEvent(requestBody, 'BUYER_CHANGE_FAVORITE_VIEW')
    }

    const generateParamsForCardView = (pageNumber, isDrafted) => {
        let params = `?page=${pageNumber}&size=20&isDrafted=${isDrafted}`
        if (sort?.key !== 'Sort') {
            params += `&sort=${sort?.value}`
        }
        if (id && id !== 'my-favourite') {
            params += `&folderId=${id}`
        }

        if (
            selectedCategoryTab?.categoryName !== 'Total' &&
            selectedCategoryTab !== null
        ) {
            if (selectedCategoryTab?.categoryId) {
                params += `&categoryIds=${selectedCategoryTab?.categoryId}`
            } else {
                params += '&isSet=true'
            }
        }

        return params
    }

    const generateParamsForTableView = (pageNumber) => {
        let params = `?page=${pageNumber}&size=20&sort=${sort?.value}`
        if (id && id !== 'my-favourite') {
            params += `&folderId=${id}`
        }

        if (
            selectedCategoryTab?.categoryName !== 'Total' &&
            selectedCategoryTab !== null
        ) {
            if (selectedCategoryTab?.categoryId) {
                params += `&categoryIds=${selectedCategoryTab?.categoryId}`
            } else if (
                selectedCategoryTab?.categoryName === 'Set' ||
                selectedCategoryTab?.fabricTypeName === 'Set'
            ) {
                params += '&isSet=true'
            } else if (selectedCategoryTab?.fabricTypeName === 'No Fabric') {
                params += '&isNoFabric=true'
            } else {
                params += `&fabricTypes=${selectedCategoryTab?.fabricType}`
            }
        }

        return params
    }

    const fetchDesignList = async (pageNumber, isDrafted = false) => {
        try {
            if (!viewType) {
                return
            }

            dispatch(openLoader())
            let data
            if (['CARD_VIEW', 'NARROW_VIEW']?.includes(viewType)) {
                data = await fetchFavouriteDetailsLists(
                    generateParamsForCardView(pageNumber, isDrafted)
                )
            } else {
                data = await fetchFavouriteDetailsListTableData(
                    generateParamsForTableView(pageNumber)
                )
            }
            if (!isDrafted) {
                await dispatch(FavouriteThunks[GET_FAVOURITE_COUNT]())

                const newData =
                    pageNumber === 0
                        ? data.data
                        : [...scrollRef.current.data, ...data.data]
                scrollRef.current = data
                scrollRef.current.data = newData
                setFavouriteList(newData)
            } else if (viewType !== 'TABLE_VIEW') {
                const newData =
                    pageNumber === 0
                        ? data.data
                        : [...draftScrollRef.current.data, ...data.data]
                draftScrollRef.current = data
                draftScrollRef.current.data = newData
                setDraftList(newData)
            }
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const handleScroll = () => {
        if (isPageReachBottom() && scrollRef.current) {
            let { totalElements, currentPage, data, totalPages } =
                scrollRef.current
            let newPage = currentPage + 1
            if (
                totalElements > 0 &&
                totalElements !== data.length &&
                !isLoading.current &&
                newPage !== totalPages
            ) {
                fetchDesignList(newPage)
            }
        }
    }

    const handleDraftScroll = () => {
        if (isPageReachBottom() && draftScrollRef.current) {
            let { totalElements, currentPage, data, totalPages } =
                draftScrollRef.current
            let newPage = currentPage + 1
            if (
                totalElements > 0 &&
                totalElements !== data.length &&
                !isLoading.current &&
                newPage !== totalPages
            ) {
                fetchDesignList(newPage)
            }
        }
    }

    const handleProductShowHide = async (
        productId,
        bool,
        addedToFavouriteById
    ) => {
        try {
            dispatch(openLoader())
            let queryParams = `?productIdList=${productId}&isHidden=${bool}&folderId=${id}&addedToFavouriteById=${addedToFavouriteById}`
            await hideLikedProduct(queryParams)
            let updatedDesignList = favouriteList.map((item) => {
                if (item.id === productId) {
                    return { ...item, isHidden: bool }
                }
                return item
            })
            setFavouriteList(updatedDesignList)
            getLikedProductCount()
            dispatch(closeLoader())
        } catch (error) {
            dispatch(closeLoader())
        }
    }

    const getLikedProductCount = async () => {
        try {
            dispatch(openLoader())
            let folderId = Number(id)

            let queryParams = `?groupByField=${sort.constant}`
            if (!isNaN(folderId)) {
                queryParams += `&folderId=${folderId}`
            }
            const data = await fetchLikedDesignCountByFolder(queryParams)
            if (data.categoryWiseCountList)
                setCategoryWiseCountList(data.categoryWiseCountList)
            if (data.fabricTypeWiseCountList)
                setFabricTypeWiseCountList(data.fabricTypeWiseCountList)
            setTotalItemsCount(data)
            dispatch(closeLoader())
        } catch (error) {
            dispatch(closeLoader())
        }
    }

    useEffect(() => {
        getLikedProductCount()
    }, [sort])

    const toggleAllSelection = async () => {
        try {
            const visibleItems = favouriteList.filter((item) => !item.isHidden)

            if (selectedIds.length >= visibleItems.length) {
                setSelectedIds([])
                setSelectedProductList([])
            } else {
                dispatch(openLoader())
                let params = ''
                if (id && id !== 'my-favourite') {
                    params += `?folderId=${id}`
                }
                const data = await fetchLikedProductInfoByFolder(params)
                const visibleIds = data
                    .filter((item) => !item.isHidden)
                    .map((item) => item.id)

                setSelectedIds(visibleIds)
                setSelectedProductList(data.filter((item) => !item.isHidden))
                dispatch(closeLoader())
            }
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const toggleSelection = (id, item = null) => {
        if (selectedIds.includes(id)) {
            setSelectedIds(selectedIds.filter((item) => item !== id))
            setSelectedProductList(
                selectedProductList.filter((product) => product?.id !== id)
            )
        } else {
            setSelectedIds((prev) => [...prev, id])
            setSelectedProductList((prev) => [...prev, item])
        }
    }

    const onToggleCategoryData = (categoryName, categoryWiseSelectedItems) => {
        let ids = categoryWiseSelectedItems?.map((item) => item.id)
        if (isAllIdExistBetweenTwoList(ids, selectedIds)) {
            setSelectedIds([])
        } else {
            setSelectedIds(ids)
        }
    }

    const toggleFavouriteModal = async (productId) => {
        try {
            dispatch(openLoader())
            await undoFavourite(productId, id)
            let tmpData = draftScrollRef.current.data.filter(
                (item) => item.id !== productId
            )
            draftScrollRef.current.totalElements =
                draftScrollRef.current.totalElements - 1
            draftScrollRef.current.data = tmpData
            setDraftList(tmpData)
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const onAddToDraft = async (design) => {
        try {
            let params = ''
            if (id && id !== 'my-favourite') {
                params = `?folderId=${id}&productIds=${design.id}`
            } else {
                params = `${design.id}`
            }
            await addToDraft(params)
            setSelectedIds([])
            let tmpData = scrollRef.current.data.filter(
                (item) => item.id !== design.id
            )

            scrollRef.current.totalElements =
                scrollRef.current.totalElements - 1
            scrollRef.current.data = tmpData
            setFavouriteList(tmpData)

            let newData = [design, ...draftScrollRef.current.data]
            draftScrollRef.current.totalElements =
                draftScrollRef.current.totalElements + 1
            draftScrollRef.current.data = newData
            fetchFolderInfos()
            setDraftList(newData)
            setSelectedProductList([])
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const onRemoveFromDraft = async (design) => {
        try {
            let params = ''
            if (id && id !== 'my-favourite') {
                params = `${design?.id}?folderId=${id}`
            } else {
                params = `${design?.id}`
            }
            await removeFromdraft(params)
            let tmpData = draftScrollRef.current.data.filter(
                (item) => item.id !== design?.id
            )

            draftScrollRef.current.totalElements =
                draftScrollRef.current.totalElements - 1
            draftScrollRef.current.data = tmpData
            setDraftList(tmpData)

            let newData = [design, ...scrollRef.current.data]
            scrollRef.current.totalElements =
                scrollRef.current.totalElements + 1
            scrollRef.current.data = newData
            setFavouriteList(newData)

            setSelectedProductList([])
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const onClickDesign = (item) => {
        dispatch(
            openDesignView({
                styleId: item.id,
                styleInfo: item,
                isShowConversation: true,
                isHideBottom: !(id && id !== 'my-favourite'),
                requestFrom: 'FAVOURITE'
            })
        )
    }

    const onClickSort = (item) => {
        setSelectedIds([])
        setSort(item)
        setShowOptions(false)
        setSelectedCategoryTab({
            categoryName: 'Total'
        })
        const requestBody = { sortingType: item?.key }
        addMixpanelTrackingEvent(
            requestBody,
            'BUYER_FAVORITE_LIST_VIEW_SORTING'
        )
    }

    const isSoldFolder = () => {
        return folderInfo?.name === 'Sold Interest'
    }

    const renderDesignCard = (favouriteData, categoryName) => {
        return (
            <>
                {categoryName ? (
                    <p className='text-xl ml-3 weight-700'>
                        {capitalizeFirstLetter(categoryName)}:{' '}
                        {favouriteData?.length}
                    </p>
                ) : null}
                <div className='px-4'>
                    <div
                        className={`design-list-container pt-5 pb-10 ${
                            viewType === 'NARROW_VIEW' ? 'image-view' : ''
                        }`}
                    >
                        {favouriteData?.map((item) => (
                            <div
                                key={`favourite_card_${item.id}`}
                                className={`${
                                    !item?.backImageDocument?.docUrl ||
                                    item?.isSet
                                        ? 'single-card-item no-rotation'
                                        : 'single-card-item'
                                }`}
                            >
                                <DesignImages
                                    designInfo={item}
                                    callback={() => onClickDesign(item)}
                                />
                                <div className='style-status flex items-center gap-1'>
                                    {item?.isSold && (
                                        <span className='status sold'>
                                            Sold
                                        </span>
                                    )}
                                    {item.isNew && (
                                        <span className='status new'>New</span>
                                    )}

                                    {item?.isPack && (
                                        <PackSetOrTag tagName='Pack' />
                                    )}
                                    {item?.isSet && (
                                        <PackSetOrTag tagName='Set' />
                                    )}
                                    {isDisabled(item) && (
                                        <WarningIcon className='mr-1' />
                                    )}
                                </div>

                                <div className='style-action'>
                                    <div>
                                        <input
                                            type='checkbox'
                                            name='categories'
                                            checked={selectedIds.includes(
                                                item.id
                                            )}
                                            onChange={() =>
                                                toggleSelection(item.id)
                                            }
                                            disabled={isSoldFolder()}
                                        />
                                    </div>
                                </div>
                                <div className='style-info'>
                                    <div
                                        className='info'
                                        onClick={() => onClickDesign(item)}
                                    >
                                        <p className='regular-18 weight-500'>
                                            {capitalizeFirstAndLowercaseRest(
                                                item?.subCategoryResponse?.name
                                            )}
                                            {item?.isSet && item?.name}
                                        </p>
                                        <ul className='common-list-component mt-1'>
                                            {!item?.isSet &&
                                                item?.mainFabricType && (
                                                    <li className='regular-14'>
                                                        {capitalizeFirstAndLowercaseRest(
                                                            item?.mainFabricType
                                                        )}
                                                    </li>
                                                )}
                                            {item?.isSet && (
                                                <SetStyleMainFabricType
                                                    product={item}
                                                />
                                            )}
                                            {item?.referenceNumber &&
                                                !item?.isSet && (
                                                    <li className='regular-14'>
                                                        {item?.referenceNumber}
                                                    </li>
                                                )}
                                        </ul>
                                    </div>
                                    <div className='favorite'>
                                        <button
                                            className='button secondary icon-only'
                                            onClick={() => onAddToDraft(item)}
                                        >
                                            <MinusIcon />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        )
    }

    const hasRecostOrApproved = selectedProductList?.some(
        (item) =>
            item?.quoteStatus === 'REQUEST_FOR_REVISION' ||
            item?.quoteStatus === 'APPROVED'
    )
    const hasUnpricedProducts = selectedProductList?.some(
        (item) => item?.offerPrice === null || item?.offerPrice === undefined
    )

    const allApproved = selectedProductList?.every(
        (item) => item?.quoteStatus === 'APPROVED'
    )

    // Conditions for enabling buttons
    const isQuoteRequoteDisabled = hasRecostOrApproved
    const isApproveQuotesDisabled = hasUnpricedProducts || hasRecostOrApproved
    const isPlaceOrderEnabled = allApproved

    const handleApproveSelectedProducts = async () => {
        try {
            const folderId = id
            const folderTitle = folderInfo?.name
            let hasError = false
            let missingQuantitiesCount = 0

            const updatedFavouriteList = favouriteList.map((product) => {
                if (
                    selectedProductList?.some(
                        (selected) => selected.id === product.id
                    )
                ) {
                    if (!product.quantity) {
                        hasError = true
                        missingQuantitiesCount++
                        return { ...product, quantityError: true }
                    }
                }

                return product
            })

            setFavouriteList(updatedFavouriteList)

            const quoteItemRequestList = selectedProductList?.map((product) => {
                let productData = {
                    productId: product.id,
                    quantity: product.quantity
                }

                if (product.quantityWiseInitialCostingId) {
                    productData.quantityWiseInitialCostingId =
                        product.quantityWiseInitialCostingId
                }
                if (product.isSet) {
                    productData.setMemberIds = product.setMemberIds || []
                    productData.set = true
                }

                return productData
            })

            if (hasError) {
                const warningMessage = `${missingQuantitiesCount} of the selected items are missing quantities. Please enter the quantity to proceed.`
                toast.warning(warningMessage)
                return
            }

            const requestBody = {
                folderId: folderId,
                title: folderTitle,
                quoteItemRequestList: quoteItemRequestList
            }

            const response = await approveQuotesByFolder(requestBody)
            if (response.success) {
                toast.success('Selected products approved successfully!')
                setSelectedIds([])
                fetchDesignList(0, false)
            }
        } catch (error) {
            printApiError(error)
        }
    }

    const onQuoteReqoteSuccess = () => {
        fetchDesignList(0, false)
        setIsQuoteShow(false)
    }

    const onSetUpdatedData = (data, id) => {
        let updatedData = [...favouriteList]
        const index = updatedData.findIndex((dataItem) => dataItem?.id === id)
        if (index !== -1) {
            const selectedItem = data.find((dataItem) => dataItem?.id === id)
            updatedData[index] = selectedItem
            setFavouriteList(updatedData)
        }
    }

    const getGroupName = (item) => {
        let groupName
        if (sort?.key === 'Category') {
            groupName = item?.categoryResponse?.name
        } else {
            groupName = item?.mainFabricType || item?.fabricType || 'No Fabric'
        }
        return groupName
    }

    const getGroupData = (groupName) => {
        let groupData = {
            name: groupName,
            count: 0,
            totalQuantity: 0,
            totalPrice: 0
        }

        if (sort?.key === 'Category') {
            const categoryData = categoryWiseCountList?.find(
                (item) =>
                    item.categoryName?.trim()?.toLowerCase() ===
                    groupName?.trim()?.toLowerCase()
            )
            if (categoryData) {
                groupData = {
                    name: categoryData?.categoryName,
                    count: categoryData?.count,
                    totalQuantity: categoryData?.totalQuantity,
                    totalPrice: categoryData?.totalPrice
                }
            }
        } else if (sort?.key === 'Fabric Type') {
            const fabricData = fabricTypeWiseCountList?.find(
                (item) =>
                    item?.fabricType
                        ?.toLowerCase()
                        ?.includes(groupName?.trim()?.toLowerCase()) ||
                    groupName
                        ?.trim()
                        ?.toLowerCase()
                        ?.includes(item?.fabricType?.toLowerCase()) ||
                    groupName
                        ?.trim()
                        ?.toLowerCase()
                        ?.includes(item?.fabricTypeName?.toLowerCase())
            )

            if (fabricData) {
                groupData = {
                    name: fabricData?.fabricType || fabricData?.fabricTypeName,
                    count: fabricData?.count,
                    totalQuantity: fabricData?.totalQuantity,
                    totalPrice: fabricData?.totalPrice
                }
            }
        }

        return groupData
    }

    const renderDesigns = (favouriteData) => {
        if (sort?.key === 'Category' || sort?.key === 'Fabric Type') {
            const groupedData = {}
            favouriteData?.forEach((item) => {
                const groupName = item?.isSet ? 'Set' : getGroupName(item) || ''
                if (!groupedData[groupName]) {
                    groupedData[groupName] = []
                }
                groupedData[groupName].push(item)
            })

            if (['CARD_VIEW', 'NARROW_VIEW']?.includes(viewType)) {
                return Object.entries(groupedData).map(([group, items]) => {
                    return renderDesignCard(items, group)
                })
            } else {
                return Object.entries(groupedData).map(([group, items]) => {
                    const groupInfo = getGroupData(group)
                    return (
                        <div key={group}>
                            <TableView
                                categoryName={group}
                                favouriteData={items}
                                setFavouriteData={(data, id) =>
                                    onSetUpdatedData(data, id)
                                }
                                selectedIds={selectedIds}
                                toggleSelection={toggleSelection}
                                toggleAllSelection={() =>
                                    onToggleCategoryData(group, items)
                                }
                                onClickDesign={onClickDesign}
                                isDisabled={isDisabled}
                                groupInfo={groupInfo} // Passing the object
                                handleProductShowHide={handleProductShowHide}
                                getLikedProductCount={getLikedProductCount}
                                selectedProductList={selectedProductList}
                                setSelectedProductList={setSelectedProductList}
                                folderInfo={folderInfo}
                            />
                        </div>
                    )
                })
            }
        } else {
            return ['CARD_VIEW', 'NARROW_VIEW']?.includes(viewType) ? (
                renderDesignCard(favouriteData)
            ) : (
                <TableView
                    favouriteData={favouriteData}
                    setFavouriteData={setFavouriteList}
                    selectedIds={selectedIds}
                    toggleSelection={toggleSelection}
                    toggleAllSelection={toggleAllSelection}
                    onClickDesign={(item) => onClickDesign(item)}
                    isDisabled={isDisabled}
                    handleProductShowHide={handleProductShowHide}
                    getLikedProductCount={getLikedProductCount}
                    selectedProductList={selectedProductList}
                    setSelectedProductList={setSelectedProductList}
                    folderInfo={folderInfo}
                />
            )
        }
    }

    const members = () => {
        return folderInfo?.members || []
    }

    const onDownLoad = async () => {
        try {
            dispatch(openLoader())
            let params = `/download-report?page=0&size=250&sort=${sort?.value}&productIds=${selectedIds}`
            if (id && id !== 'my-favourite') {
                params += `&folderId=${id}`
            }
            const response = await Http.GET_FILE_DATA(
                'fetchBuyerLikedDesignsSummary',
                params
            )
            downloadBlobFIle(response)
            setSelectedIds([])
            dispatch(closeLoader())
        } catch ({ response }) {
            dispatch(closeLoader())
            if (response) toast.error(response.data.message)
            else toast.error('Something went wrong')
        }
    }

    const renderEmptyView = () => {
        return (
            <>
                <div
                    className={`description ${
                        folderInfo?.name === 'Sold Interest' ? 'hidden' : ''
                    }`}
                >
                    <p className='regular-12 max-w-[640px]'>
                        {folderInfo?.description}
                    </p>
                </div>
                <div className='epmpty-state py-40 text-center max-w-[600px] m-auto'>
                    <h3 className='regular-20 weight-700 gray_400 mb-2'>
                        No design found.
                    </h3>
                    <p className='regular-12 gray_300'>
                        Explore our design lab to add designs in this folder
                    </p>
                    <div className='mt-6'>
                        <button
                            className='button primary sm'
                            onClick={() => navigate('/design-lab')}
                        >
                            Visit Design Lab
                        </button>
                    </div>
                </div>
            </>
        )
    }

    const renderDraftViewButton = () => {
        return (
            <div>
                {isShowDraft ? (
                    <button
                        className='button primary sm round hidden sm:flex items-center '
                        onClick={() => setIsShowDraft(false)}
                    >
                        {' '}
                        <span className='mr-1'>Hide</span>
                        <RightArrowIcon />
                    </button>
                ) : (
                    <button
                        className='button primary sm round hidden sm:flex items-center'
                        onClick={() => setIsShowDraft(true)}
                    >
                        {' '}
                        <LeftArrowIcon />
                        <span className='ml-1'>
                            Draft ({draftList?.length})
                        </span>
                    </button>
                )}
            </div>
        )
    }

    const renderSortingDropdown = () => {
        return (
            <div className='block'>
                <CustomDropdown
                    label={'Default'}
                    icon={<DownArrowIcon />}
                    selectedOption={sort.key}
                    isShowOptions={showOptions}
                    setIsShowOptions={setShowOptions}
                >
                    <div className='list-items scroll-y-label cursor-pointer'>
                        {sortOptions
                            ?.slice(
                                0,
                                ['CARD_VIEW', 'NARROW_VIEW']?.includes(viewType)
                                    ? 3
                                    : sortOptions.length
                            )
                            .map((item) => {
                                return (
                                    <div
                                        key={`sort_${item.key}`}
                                        className='single-item'
                                        onClick={() => {
                                            onClickSort(item)
                                        }}
                                    >
                                        <p>{item.key}</p>
                                    </div>
                                )
                            })}
                    </div>
                </CustomDropdown>
            </div>
        )
    }

    const onPlaceOrderSuccess = (data) => {
        const updatedFavouriteList = favouriteList.map((item) => {
            const matchingDataItem = data.find(
                (dataItem) => dataItem.id === item.id
            )
            if (matchingDataItem) {
                return { ...item, ...matchingDataItem }
            }
            return item
        })
        setFavouriteList(updatedFavouriteList)
    }

    const handleCategoryTabClick = (item) => {
        setSelectedCategoryTab(item)
    }

    useEffect(() => {
        if (selectedCategoryTab) {
            fetchDesignList(0, false)
        }
    }, [selectedCategoryTab])

    const renderCategoryWiseCountList = () => {
        return (
            <div className='flex flex-wrap gap-2'>
                {categoryWiseCountList?.length > 0 &&
                    categoryWiseCountList?.map(
                        (item, idx) =>
                            item.categoryName && (
                                <button
                                    key={`category_${idx}`}
                                    className={`text-sm px-3 py-1 rounded-full ${
                                        isTabSelected(item)
                                            ? 'bg-primary text-white'
                                            : 'bg-gray-100 hover:bg-gray-200'
                                    }`}
                                    onClick={() => handleCategoryTabClick(item)}
                                >
                                    {capitalizeFirstLetter(item?.categoryName)}
                                    &nbsp;({item?.count})
                                </button>
                            )
                    )}
            </div>
        )
    }

    const isTabSelected = (item) => {
        const selectedName =
            selectedCategoryTab?.categoryName ||
            selectedCategoryTab?.fabricTypeName
        const itemName = item?.categoryName || item?.fabricTypeName
        return selectedName === itemName
    }

    const renderFabricWiseCountList = () => {
        return (
            <div className='flex flex-wrap gap-2'>
                {fabricTypeWiseCountList?.length > 0 &&
                    fabricTypeWiseCountList?.map((item, idx) => (
                        <button
                            key={`fabric_${idx}`}
                            className={`text-sm px-3 py-1 rounded-full ${
                                isTabSelected(item)
                                    ? 'bg-primary text-white'
                                    : 'bg-gray-100 hover:bg-gray-200'
                            }`}
                            onClick={() => handleCategoryTabClick(item)}
                        >
                            {capitalizeFirstLetter(
                                item?.categoryName || item?.fabricTypeName
                            )}
                            &nbsp;({item?.count})
                        </button>
                    ))}
            </div>
        )
    }

    useEffect(() => {
        if (favouriteList?.length > 0) {
            if (viewType === 'TABLE_VIEW') {
                const styleList = favouriteList?.map((item) => {
                    return {
                        id: item?.id,
                        name: item?.name,
                        referenceNumber: item?.referenceNumber,
                        isSet: item?.isSet || false,
                        designDocuments: item?.docUrl
                            ? [item?.docUrl]
                            : item?.setMemberDocUrls
                    }
                })
                setStyleListForMentions(styleList)
            } else {
                setStyleListForMentions(favouriteList)
            }
        }
    }, [favouriteList, viewType])

    const handleOpenFolderConversation = () => {
        dispatch(
            openConversationView({
                id: id,
                type: 'FAVOURITE_FOLDER_COMMENT',
                styleList: styleListForMentions,
                conversationsType: 'FOLDER_CONVERSATION'
            })
        )
    }

    return (
        <>
            <div className='favourite-details-container flex'>
                <div
                    className={`${
                        isShowDraft
                            ? 'favourite-details-data pb-24 collapsed'
                            : 'favourite-details-data pb-24'
                    }`}
                >
                    <div className='flex flex-wrap sm:flex-nowrap items-center justify-between py-3 pr-4'>
                        <div>
                            {breadCrumbs?.length > 0 ? (
                                <BreadCrumb />
                            ) : (
                                <p className='regular-14 weight-500 px-4'>
                                    {folderInfo?.name}
                                </p>
                            )}
                        </div>
                        <div className='ml-4 mt-4 sm:ml-0 sm:!mt-0'>
                            {id > 0 && (
                                <AddPeople
                                    requestFrom={'FAVOURITE_DETAILS'}
                                    members={members()}
                                    callback={fetchFolderInfos}
                                />
                            )}
                        </div>
                    </div>
                    <div className='flex flex-wrap sm:flex-nowrap justify-end pt-3 px-4'>
                        {['CARD_VIEW', 'NARROW_VIEW']?.includes(viewType) &&
                            renderDraftViewButton()}
                    </div>

                    {scrollRef?.current?.totalElements === 0 &&
                    !globalLoader ? (
                        <div className='py-3 px-4'>{renderEmptyView()}</div>
                    ) : (
                        <div>
                            <div className='flex flex-wrap sm:flex-nowrap justify-between pt-3 px-4'>
                                <div>
                                    <div className='actions mb-3 sm:!mb-0'>
                                        <button
                                            className='button !p-0 min-w-[44px]'
                                            onClick={() =>
                                                toggleDesignViewType(
                                                    'CARD_VIEW'
                                                )
                                            }
                                        >
                                            <Tooltip
                                                className={
                                                    screenWidth > 640
                                                        ? ''
                                                        : '!hidden'
                                                }
                                                title='Card view'
                                            >
                                                {viewType === 'CARD_VIEW' ? (
                                                    <SelectedCardViewIcon className='!w-[44px] !h-[44px]' />
                                                ) : (
                                                    <CollectionUnFillIcon className='!min-w-[24px] !min-h-[24px]' />
                                                )}
                                            </Tooltip>
                                        </button>

                                        <button
                                            className='button !p-0 min-w-[44px]'
                                            onClick={() =>
                                                toggleDesignViewType(
                                                    'TABLE_VIEW'
                                                )
                                            }
                                        >
                                            <Tooltip title='List view'>
                                                {viewType === 'TABLE_VIEW' ? (
                                                    <SelectedListViewIcon className='!w-[44px] !h-[44px]' />
                                                ) : (
                                                    <ListViewUnfillIcon className='!w-[24px] !h-[24px]' />
                                                )}
                                            </Tooltip>
                                        </button>
                                    </div>
                                    <div
                                        className={`description mt-4 ${
                                            folderInfo?.name === 'Sold Interest'
                                                ? 'hidden'
                                                : ''
                                        }`}
                                    >
                                        <p className='regular-12 max-w-[640px]'>
                                            {folderInfo?.description}
                                        </p>
                                    </div>
                                </div>
                                {screenWidth < 640 && renderSortingDropdown()}
                            </div>
                            <div className='flex flex-wrap sm:flex-nowrap justify-between items-center py-3 px-4 gap-4'>
                                <div className='flex flex-wrap gap-x-3 gap-y-2'>
                                    <button
                                        className={`text-sm px-3 py-1 rounded-full ${
                                            selectedCategoryTab?.categoryName ===
                                                'Total' ||
                                            selectedCategoryTab === null
                                                ? 'bg-primary text-white'
                                                : 'bg-gray-100 hover:bg-gray-200'
                                        }`}
                                        onClick={() =>
                                            handleCategoryTabClick({
                                                categoryName: 'Total'
                                            })
                                        }
                                    >
                                        Total:{' '}
                                        {categoryWiseCountList?.length > 0
                                            ? categoryWiseCountList?.reduce(
                                                  (acc, item) =>
                                                      acc + item?.count,
                                                  0
                                              )
                                            : 0}
                                    </button>

                                    {sort.constant === 'FABRIC_TYPE'
                                        ? renderFabricWiseCountList()
                                        : renderCategoryWiseCountList()}
                                </div>
                                {isPickAndChooseBuyer() &&
                                    viewType === 'TABLE_VIEW' && (
                                        <div className='flex align-items-center gap-3'>
                                            <div className='bg-[#FFD162] px-2 flex items-center h-9 rounded'>
                                                <p className='semibold-16 whitespace-nowrap'>
                                                    {
                                                        totalItemsCount?.totalQuantity
                                                    }{' '}
                                                    Units
                                                </p>
                                                <span className='semibold-16 text-[#F6BC2F] mx-2'>
                                                    |
                                                </span>
                                                <p className='semibold-16'>
                                                    $
                                                    {totalItemsCount?.totalPrice?.toFixed(
                                                        2
                                                    )}
                                                </p>
                                            </div>
                                            {screenWidth > 640 &&
                                                renderSortingDropdown()}
                                        </div>
                                    )}
                            </div>
                            {renderDesigns(favouriteList)}
                        </div>
                    )}
                </div>

                {isShowDraft && (
                    <div className='draft-board px-3 scroll-y-label'>
                        <div className='draft-board-header py-4'>
                            <div className='flex justify-between items-center'>
                                <h3 className='text-xl font-bold'>
                                    Draft Board
                                </h3>
                                <CloseIcon
                                    className='cursor-pointer'
                                    onClick={() => setIsShowDraft(false)}
                                />
                            </div>
                            <p className='text-sm mt-2'>
                                Total:{' '}
                                <span className='weight-500'>
                                    {draftScrollRef?.current?.totalElements}
                                </span>{' '}
                            </p>
                        </div>
                        <div className='draft-board-body pb-4'>
                            <div className='grid grid-cols-1 gap-4'>
                                {draftList?.map((item) => (
                                    <div
                                        className={`single-card-item ${
                                            item?.isSet ? 'no-rotation' : ''
                                        }`}
                                        key={item?.id}
                                    >
                                        <DesignImages
                                            designInfo={item}
                                            callback={() => onClickDesign(item)}
                                        />
                                        <div className='style-action'>
                                            <DeleteIcon
                                                className='cursor-pointer'
                                                onClick={() =>
                                                    toggleFavouriteModal(
                                                        item?.id
                                                    )
                                                }
                                            />
                                        </div>
                                        <button
                                            disabled={viewType === 'TABLE_VIEW'}
                                            className='button secondary icon-only absolute right-2 bottom-2'
                                            onClick={() =>
                                                onRemoveFromDraft(item)
                                            }
                                        >
                                            <PlusIcon />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {screenWidth < 640 && (
                <div
                    id='draft'
                    className='selected-item-count flex justify-center'
                >
                    <div className='text-center'>
                        {isShowDraft ? (
                            <button
                                className='button primary sm round'
                                onClick={() => setIsShowDraft(false)}
                            >
                                {' '}
                                <span className='mr-1'>Hide</span>
                                <RightArrowIcon />
                            </button>
                        ) : (
                            <button
                                className='button primary sm round'
                                onClick={() => setIsShowDraft(true)}
                            >
                                <LeftArrowIcon />
                                <span className='ml-2'>
                                    Draft ({draftList?.length})
                                </span>
                            </button>
                        )}
                    </div>
                </div>
            )}

            {selectedIds.length > 0 && (
                <div
                    id='quote-big'
                    className='selected-item-count sm:flex justify-center block on-favourite'
                >
                    <div className='item-count-content items-center sm:flex justify-between max-w-[1200px] w-full block'>
                        <div className='flex items-center justify-center mt-[22px] sm:mt-0'>
                            <p className='regular-18'>
                                {selectedIds.length}{' '}
                                {selectedIds.length > 1 ? 'Items' : 'Item'}
                            </p>
                            <span className='px-4'>|</span>
                            <button
                                className='button link'
                                onClick={toggleAllSelection}
                            >
                                {selectedIds.length ===
                                scrollRef?.current?.totalElements
                                    ? 'Unselect'
                                    : 'Select'}{' '}
                                all
                            </button>
                        </div>

                        <div className='sm:text-start text-center mt-[30px] sm:!mt-0 flex flex-wrap gap-3 xl:gap-4 justify-center'>
                            <button
                                className='button button-fav primary round'
                                onClick={() => setIsQuoteShow(true)}
                                disabled={isQuoteRequoteDisabled}
                            >
                                Quote/Re-quote
                            </button>
                            <button
                                className='button button-fav primary round'
                                disabled={isApproveQuotesDisabled}
                                onClick={() => handleApproveSelectedProducts()}
                            >
                                Approve Quotes
                            </button>
                            <button
                                className='button button-fav primary round'
                                onClick={() => setIsShowSample(true)}
                            >
                                Sample
                            </button>
                            <button
                                className='button primary round'
                                onClick={() => setIsPlaceOrder(true)}
                                disabled={!isPlaceOrderEnabled}
                            >
                                Place order
                            </button>
                            <button
                                className='button button-fav secondary round'
                                onClick={() => onDownLoad()}
                            >
                                Summary Sheet
                                <span className='ml-2'>
                                    <DownloadIcon />
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {id > 0 && (
                <button
                    onClick={handleOpenFolderConversation}
                    className='button primary w-[55px] h-[55px] flex items-center justify-center icon-only fixed right-6 bottom-16 xl:bottom-8 !rounded-full'
                >
                    <ChatIcon />
                </button>
            )}

            {isShowPresentation && (
                <PresentationViewModal
                    onClose={() => setIsShowPresentation(false)}
                    pageSource='FAVOURITE'
                />
            )}

            {isQuoteShow && (
                <RequestForQuotes
                    defaultTitle={folderInfo?.name || ''}
                    selectedProductList={selectedIds}
                    onCLose={() => {
                        setIsQuoteShow(false)
                    }}
                    onSuccess={onQuoteReqoteSuccess}
                    type={'QUOTE_REQUEST_FROM_FAVOURITE_FOLDER'}
                />
            )}

            {isShowSample && (
                <RequestForSample
                    defaultTitle={folderInfo?.name || ''}
                    type='SAMPLE_REQUEST_FROM_FAVOURITE'
                    selectedProductList={selectedIds}
                    onCLose={() => {
                        setIsShowSample(false)
                    }}
                    onSubmitSample={() => {}}
                />
            )}

            {isPlaceOrder && (
                <PlaceOrder
                    details={{
                        quote: {
                            title: folderInfo?.name,
                            fromFav: true,
                            folderId: id
                        }
                    }}
                    handleClose={() => {
                        setSelectedIds([])
                        setIsPlaceOrder(false)
                    }}
                    selectedProducts={selectedIds}
                    collectionId={folderInfo?.collectionId}
                    onSuccess={(data) => onPlaceOrderSuccess(data)}
                />
            )}
        </>
    )
}

export default FavouriteDetails
